/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invalideventdataerror3Inputs */

const en_invalideventdataerror3 = /** @type {(inputs: Invalideventdataerror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The provided event data is invalid.`)
};

const de_invalideventdataerror3 = /** @type {(inputs: Invalideventdataerror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Angaben zum Event sind ungültig.`)
};

/**
* | output |
* | --- |
* | "The provided event data is invalid." |
*
* @param {Invalideventdataerror3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const invalideventdataerror3 = /** @type {((inputs?: Invalideventdataerror3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invalideventdataerror3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_invalideventdataerror3(inputs)
	return de_invalideventdataerror3(inputs)
});
export { invalideventdataerror3 as "invalidEventDataError" }